import { useWidget } from '@telescope/cassini-hooks';
import { Box, Container, Heading, Image, Link } from '@telescope/cassini-ui';
import { Text } from 'components';
import { Closed } from 'generated-types/widget';

export const ClosedPage = () => {
  const { data } = useWidget<Closed>({ select: (data) => data.snapshot.snapshot_views.closedPage });
  const { content, styles } = data;

  return (
    <Container as="section" className="ClosedPage__root" {...styles?.root} mt={50}>
      <Heading
        className="ClosedPage__headline"
        as="h1"
        textAlign="center"
        size="md"
        variant="emphasized"
        mb={2}
        {...styles?.headline}>
        {content.headline}
      </Heading>
      <Text className="ClosedPage__description" textAlign="center" mb={4} allowMarkdown {...styles?.description}>
        {content.description}
      </Text>
      <Box className="ClosedPage__sponsor-container" textAlign="center" mt={10} {...styles?.image}>
        <Text allowMarkdown className="ClosedPage__sponsor-text" {...styles?.sponsorText} mb={4}>
          {content.sponsorText}
        </Text>
        <Link
          className="ClosedPage__sponsor-link"
          href={content.sponsorLink}
          target="_blank"
          display="inline-block"
          {...styles?.sponsorLink}>
          <Image className="ClosedPage__sponsor-logo" src={content.sponsorLogo} alt="" {...styles?.sponsorLogo} />
        </Link>
      </Box>
    </Container>
  );
};
